import React, { useEffect, useRef } from 'react'
import '../css/logo.css';
import theme from '../theme';

const markerPlace = "https://res.cloudinary.com/wikimenu/image/upload/v1691719276/store-app/sight-a_hnsg8d.png"


export default function Marker(props) {
  
   const {googleMap,show, geopoint} = props; 
   //console.debug("Marker geopoint: ",geopoint);   
  
   const marker = useRef(null);   
   

   useEffect(() => {
      if (marker.current){         
         marker.current.setMap(null);
      }

      if(show){
      marker.current =  new window.google.maps.Marker({         
         position:  new window.google.maps.LatLng( geopoint.latitude,   geopoint.longitude),
         icon:markerPlace 
       });
      marker.current.setMap(googleMap.current);
      }
    }, [show,geopoint]);

 
   return (
      ""
   )
}
